import { render, staticRenderFns } from "./AcknowledgedColumn.vue?vue&type=template&id=447a26ae"
import script from "./AcknowledgedColumn.vue?vue&type=script&lang=ts"
export * from "./AcknowledgedColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports